import { render } from "./EnvioErrores.vue?vue&type=template&id=2ded0e6e"
import script from "./EnvioErrores.vue?vue&type=script&lang=js"
export * from "./EnvioErrores.vue?vue&type=script&lang=js"

import "./EnvioErrores.vue?vue&type=style&index=0&id=2ded0e6e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__